import {useEffect} from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  nextPage,
  previousPage,
  questionAnswered,
  selectCostQuestions,
  selectPage,
  resetPage,
  selectCostComplete
} from "../features/cost/costSlice.js";
import costIcon from "../assets/Navigation/nav_icon_cost_green.png";
import SideNav from "../components/SideNav";
import PageTitle from "../components/PageTitle";
import { Link } from "react-router-dom";
import configA from '../assets/well_config_question/question_well_config_A.jpg'
import configB from '../assets/well_config_question/question_well_config_B.jpg'
import configC from '../assets/well_config_question/question_well_config_C.jpg'
import capex from '../assets/Popups/popup_capex_graphic.jpg'
import capexStat from '../assets/Popups/popup_industry_stat_50.png'
import SlideOut from "../components/SlideOut.js";
import ArrowForwardIos from "@mui/icons-material/ArrowForwardIos";
import { ArrowBackIos } from "@mui/icons-material";
import { Button, Container } from "@mui/material";

const Cost = () => {
  const page = useSelector(selectPage)
  const questions = useSelector(selectCostQuestions)
  const dispatch = useDispatch();
  const section = {
    title: "Ahorro de costos",
    icon: costIcon,
    pages: [1, 2, 3],
  };


  const isComplete = useSelector(selectCostComplete)
  useEffect(
    ()=>!isComplete ? dispatch(resetPage()):null,[]
  )

  const capexSavings = {
    title: 'Reduzca los costos operativos',
    copy: 'El uso del caudalímetro multifásico (MPFM) Roxar 2600 puede ayudar a su operación a reducir los costos mediante:',
    bullets: [<li>Reducir las intervenciones de mantenimiento</li>,<li>Reducir las piezas de repuesto/reducir el inventario</li>,<li>Planes de reparación eficientes gracias a una visión inmediata de los datos: mantenimiento planificado en lugar de imprevisto/de emergencia</li>],
    stat:{
      copy:`En la construcción inicial de la plataforma de pozos, cambiar de un separador por pozo a un medidor multifase por pozo.*`,
      graphic: capexStat
    },
    view:{
      vert:true,
      copy:['ver gráfico:',<br/>,'Diferencial de CAPEX'],
      header:['Diferencial de CAPEX $:'],
      paragraph:['(% promedio, de productores norteamericanos para separadores, instrumentos, líneas de caudal, tanques)'],
      graphic: capex
    }
  }

  return (
    <Container className="content_container" maxWidth='lg'>
    <div className="roxar_content">
      <div className="main_content">
        <PageTitle section={section} currentPage={page} />
        <div className="page_contents">
          {page === 1 && (
            <div className="challenges"> 
              <div>
                <h1>Desafíos de producción</h1>
                <ul>
                  <li>
                  Gastos CAPEX en separadores, líneas de caudal, etc. 
                  </li>
                  <li>
                  Gastos OPEX en mantenimiento imprevisto e incrementado, piezas de repuesto
                  </li>
                  <li>
                  Costo de la resolución de problemas/demora desde la avería hasta el plan de reparación para arreglarla
                  </li>
                </ul>
              </div>
              <div className="solution_copy">
                <p>
                Una mala separación y un mantenimiento frecuente pueden ejercer presión sobre su cuenta de resultados. Con menos intervenciones de mantenimiento, el caudalímetro multifásico (MPFM) Roxar 2600 puede ayudar a mantener los costos bajos y reducir significativamente la inversión de CAPEX.
                </p>
                <Button className="forward_button production_button" onClick={() => dispatch(nextPage())}>Aprenda cómo</Button>
              </div>
            </div>
          )}
          {page === 2 && (
            <div className="questions">
              <div>
                  <h3 className="question">P: Elija la configuración que mejor se adapte a su plataforma de pozos.</h3>
                  <div className="answers">
                      <div className="well_pad_answer">
                      <Button className={`answer ${questions[0].answer=='A'?'active_answer':null}`} onClick={(e)=> dispatch(questionAnswered({question:0,answer:'A', score:1, max: 3}))}> A</Button><p>Un separador de prueba por pozo con un separador de producción para toda la plataforma de pozos</p><img className='well_pad_image' src={configA} />

                      </div>
                      <div className="well_pad_answer">
                      <Button className={`answer ${questions[0].answer=='B'?'active_answer':null}`} onClick={(e)=> dispatch(questionAnswered({question:0,answer:'B', score:2, max: 3}))}> B</Button><p>Un separador de prueba en un manifold que maneja múltiples pozos, con un separador de producción para toda la plataforma de pozos</p><img className='well_pad_image' src={configB} />

                      </div>
                      <div className="well_pad_answer">
                      <Button className={`answer ${questions[0].answer=='C'?'active_answer':null}`} onClick={(e)=> dispatch(questionAnswered({question:0,answer:'C', score:3, max: 3}))}> C</Button><p>Un separador de prueba en un manifold que maneja múltiples pozos, con un separador de producción aguas abajo, fuera de la plataforma (plataformas mixtas, intereses de regalías comunes)</p><img className='well_pad_image' src={configC} />

                      </div>
                      <div className="well_pad_answer">
                      <Button className={`answer ${questions[0].answer=='D'?'active_answer':null}`} onClick={(e)=> dispatch(questionAnswered({question:0,answer:'D', score:0, max: 0}))}>D</Button> <p>Otro</p>

                      </div>
                  </div>
              </div>
              <div className="page_nav">
                  <Button className="prev_button" onClick={() => dispatch(previousPage())}><ArrowBackIos /><span>Anterior</span></Button>
                  <Button className="next_button" onClick={() => dispatch(nextPage())}><span>Siguiente</span><ArrowForwardIos /></Button>
              </div>
            </div>
          )}
          {page === 3 && (
              <div className="questions">
              <div>
                  <h3 className="question">P: ¿Cuál es su gasto medio de CAPEX en un separador de prueba totalmente instrumentado?</h3>
                  <div className="answers">
                  <Button className={`answer ${questions[1].answer=='Menos de 100 000 USD'?'active_answer':null}`} onClick={(e)=> dispatch(questionAnswered({question:1,answer:'Menos de 100 000 USD', score:5, max: 5}))}>Menos de 100 000 USD</Button>
                  <Button className={`answer ${questions[1].answer=='De 100 000 a 250 000 USD'?'active_answer':null}`} onClick={(e)=> dispatch(questionAnswered({question:1,answer:'De 100 000 a 250 000 USD', score:4, max: 5}))}>De 100 000 a 250 000 USD</Button>
                  <Button className={`answer ${questions[1].answer=='De 250 000 a 500 000 USD'?'active_answer':null}`} onClick={(e)=> dispatch(questionAnswered({question:1,answer:'De 250 000 a 500 000 USD', score:3, max: 5}))}>De 250 000 a 500 000 USD</Button>
                  <Button className={`answer ${questions[1].answer=='De 500 000 a 1 000 000 USD'?'active_answer':null}`} onClick={(e)=> dispatch(questionAnswered({question:1,answer:'De 500 000 a 1 000 000 USD', score:2, max: 5}))}> De 500 000 a 1 000 000 USD</Button>   
                  <Button className={`answer ${questions[1].answer=='Más de 1 000 000 USD'?'active_answer':null}`} onClick={(e)=> dispatch(questionAnswered({question:1,answer:'Más de 1 000 000 USD', score:1, max: 5}))}>Más de 1 000 000 USD</Button>   
                  </div>
              </div>
              <div>
                  <h3 className="question">P: En lo que respecta a los separadores y equipos asociados, ¿cuál es el valor estimado en dólares de las piezas de repuesto/inventario que tiene a mano?</h3>
                  <div className="answers">
                  <Button className={`answer ${questions[2].answer=='Ninguna. (Realice el pedido según sea necesario)'?'active_answer':null}`} onClick={(e)=> dispatch(questionAnswered({question:2,answer:'Ninguna. (Realice el pedido según sea necesario)', score:1, max: 3}))}>Ninguna. (Realice el pedido según sea necesario)</Button>
                  <Button className={`answer ${questions[2].answer=='Menos de 10 000 USD'?'active_answer':null}`} onClick={(e)=> dispatch(questionAnswered({question:2,answer:'Menos de 10 000 USD', score:2, max: 3}))}>Menos de 10 000 USD</Button>  
                  <Button className={`answer ${questions[2].answer=='De 10 000 a 50 000 USD'?'active_answer':null}`} onClick={(e)=> dispatch(questionAnswered({question:2,answer:'De 10 000 a 50 000 USD', score:3, max: 3}))}>De 10 000 a 50 000 USD</Button>  
                  <Button className={`answer ${questions[2].answer=='De 50 000 a 100 000 USD'?'active_answer':null}`} onClick={(e)=> dispatch(questionAnswered({question:2,answer:'De 50 000 a 100 000 USD', score:2, max: 3}))}>De 50 000 a 100 000 USD</Button>  
                  <Button className={`answer ${questions[2].answer=='Más de 100 000 USD'?'active_answer':null}`} onClick={(e)=> dispatch(questionAnswered({question:2,answer:'Más de 100 000 USD', score:1, max: 3}))}>Más de 100 000 USD</Button>  
                  </div>
              </div>
              <div className="page_nav">
              <Button className="prev_button" onClick={() => dispatch(previousPage())}><ArrowBackIos /><span>Anterior</span></Button>
                  <Button className="next_button"  component={Link} to={'/results'}><span>Siguiente</span><ArrowForwardIos /></Button>
              </div>
              <div>
                  <Button component={Link} to='/results' className="next_button view_results">Ver los resultados de la sección</Button>
              </div>
              <div className='bottom_filler'>

              </div>
            </div>
          )}
        </div>
      </div>
      {page === 3 && (
      <SlideOut title={capexSavings.title} copy={capexSavings.copy}  bullets={capexSavings.bullets} view={capexSavings.view} stat={capexSavings.stat}/>
    )}
      <SideNav />
    </div>
    </Container>
  );
};

export default Cost;